export default "__VITE_ASSET__Bw7XjtqR__"